import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import "../Logistics/Logistics.scss";

const Construction = () => {
  return (
    <>
      <div className="logistics-con">
        <p className="title">
          <StaticImage
            className="service-badge"
            src="../../../images/svg/construction.svg"
            width={45}
            quality={100}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="badge"
          />
          Port Facility Development
        </p>

        <div className="d-flex flex-row service-ch-land">
          <div className="logistics-left">
            <div className="logistics">
              <StaticImage
                className="ch-img"
                src="../../../images/construction.png"
                width={400}
                quality={100}
                formats={["AUTO", "WEBP", "AVIF"]}
                alt="about us"
              />

              <div className="text">
                {/* <p className="label">Stevedoring & Arrastre</p> */}
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum
                  dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                  tempor incididunt ut labore et dolore magna aliqua.
                </p>
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Construction;
